import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconBurgerStyle0 = gravityIconIndividualCss;

const GravityIconBurger = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '1c6d660101dafed6e19398f25c9e11ba7a0013a9', color: this.color, size: this.size }, h("svg", { key: '8d49b210bde1a264b0a6dff41f26ce84f440f5df', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '3e83753c4406ce460b35645fe0e434763216414c', d: "M3 5.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5h-15A.5.5 0 0 1 3 6v-.5Zm0 5.25a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-.5Zm.5 4.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5V16a.5.5 0 0 0-.5-.5h-15Z", fill: "currentColor" }))));
    }
};
GravityIconBurger.style = GravityIconBurgerStyle0;

export { GravityIconBurger as gravity_icon_burger };

//# sourceMappingURL=gravity-icon-burger.entry.js.map